import './style.scss'
import { Row , Col } from '../grid'

export default {
  name: 'List',
  props: {
    loading: {
      type: Boolean,
      default:false
    },
    grid:{
      type:Object,
      default(){
        return {}
      }
    },
    data: {
      default() {
        return []
      }
    },
  },

  methods: {
    renderItem(data){
      const { $scopedSlots } = this
      const titleNode = data.title ? data.title : $scopedSlots.title ? $scopedSlots.title(data) : null

      const descNode = data.description ? data.description : $scopedSlots.description ? $scopedSlots.description(data) : null

      const contentNode = $scopedSlots.default ? $scopedSlots.default(data) : null

      const actionsNode = $scopedSlots.actions ? $scopedSlots.actions(data) : []
      return (
        <div class="sl-list-item">
          <div class="sl-list-item-extra-wrap">
            <div class="sl-list-item-main">
              <div class="sl-list-item-meta">
                <div class="sl-list-item-meta-content">
                  <h4 class="sl-list-item-meta-title">{titleNode}</h4>
                  <div class="sl-list-item-meta-description">{descNode}</div>
                </div>
              </div>
              <div class="sl-list-item-content">{contentNode}</div>
              <ul class="sl-list-item-action">
                {
                  actionsNode.map((i , idx)=>{
                    return <li>
                      {i}
                      { idx < actionsNode.length - 1 ? <em class="sl-list-item-action-split"></em> : null }
                    </li>
                  })
                }
              </ul>
            </div>
          </div>
        </div>
      )
    },
    wrapGrid(nodes){
      const { grid } = this;
      const enable = Object.keys(grid).length > 0;
      console.log(grid)
      if(enable){
        let { column , gutter , ...responsive} = grid
        if( column && [ 1, 2, 3, 4, 6, 8, 12, 24].includes(column)){
          responsive.span = column
        }

        let layout = {}
        if(gutter) layout.gutter = gutter

        for(let i in responsive){
          responsive[i] = Math.round(24 / responsive[i])
        }
        return (
          <Row {...{props:layout}}>
            {
              nodes.map( node => (
                <Col {...{props:responsive}}>{node}</Col>
              ))
            }
          </Row>
        )
      }
      
      return nodes
      
    }
  },
  render() {
    const { renderItem , wrapGrid} = this
    return (
      <div class="sl-list">
        {wrapGrid(this.data.map( renderItem ))}
      </div>
    )
  }
}